import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Users, BarChart3, Settings } from 'lucide-react';

const Dashboard = () => {
  const stats = [
    {
      title: 'Total Forms',
      value: '12',
      description: 'Active form schemas',
      icon: FileText,
    },
    {
      title: 'Active Users',
      value: '1,234',
      description: 'Registered users',
      icon: Users,
    },
    {
      title: 'Submissions',
      value: '5,678',
      description: 'Form submissions this month',
      icon: BarChart3,
    },
    {
      title: 'System Health',
      value: '99.9%',
      description: 'Uptime this month',
      icon: Settings,
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Dashboard</h1>
        <p className="text-muted-foreground mt-2">
          Overview of your admin panel metrics and quick actions.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title}>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">
                  {stat.title}
                </CardTitle>
                <Icon className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{stat.value}</div>
                <p className="text-xs text-muted-foreground">
                  {stat.description}
                </p>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Recent Activity</CardTitle>
            <CardDescription>
              Latest form submissions and user activities
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <div className="flex-1 space-y-1">
                  <p className="text-sm font-medium">New form submission</p>
                  <p className="text-xs text-muted-foreground">Project Report #123</p>
                </div>
                <p className="text-xs text-muted-foreground">2 min ago</p>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <div className="flex-1 space-y-1">
                  <p className="text-sm font-medium">User registered</p>
                  <p className="text-xs text-muted-foreground">john.doe@example.com</p>
                </div>
                <p className="text-xs text-muted-foreground">5 min ago</p>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                <div className="flex-1 space-y-1">
                  <p className="text-sm font-medium">Form schema updated</p>
                  <p className="text-xs text-muted-foreground">Reports Form v2.1</p>
                </div>
                <p className="text-xs text-muted-foreground">10 min ago</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Quick Actions</CardTitle>
            <CardDescription>
              Common administrative tasks
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <button className="w-full text-left p-3 rounded-lg border border-border hover:bg-accent transition-colors">
                <div className="font-medium">Create New Form Schema</div>
                <div className="text-sm text-muted-foreground">Add a new form template</div>
              </button>
              <button className="w-full text-left p-3 rounded-lg border border-border hover:bg-accent transition-colors">
                <div className="font-medium">Export Data</div>
                <div className="text-sm text-muted-foreground">Download submission reports</div>
              </button>
              <button className="w-full text-left p-3 rounded-lg border border-border hover:bg-accent transition-colors">
                <div className="font-medium">Manage Users</div>
                <div className="text-sm text-muted-foreground">User roles and permissions</div>
              </button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;